import { QuestionnaireQuestion, UpdateQuestionnaireQuestionBulkInput } from '@/models/gen/graphql';

import { UpdateQuestionnaireQuestionBulkDocument } from '@/api/queries';
import { generateUpdateBulkPayload } from '@/utils';
import graphApi from '@/api';

const [runUpdateQuestion] = graphApi(UpdateQuestionnaireQuestionBulkDocument);

export const updateQuestion = async (questions: Partial<QuestionnaireQuestion>[]) => {
  const updates = generateUpdateBulkPayload(questions);
  const input: UpdateQuestionnaireQuestionBulkInput = { updates };
  return await runUpdateQuestion({ input });
};

export default updateQuestion;
